<template>
  <SummarySection :sections="sections" />
</template>

<script lang="ts">
import { parseISO } from 'date-fns';
import { format } from 'date-fns-tz';
import { mapGetters } from 'vuex';
import { dateFormatted, timeFrame } from '@/lib/interviews/data_formatter_util';
import SummarySection from '@/components/summarySection/SummarySection.vue';

export default {
  name: 'ConfirmationStep',
  components: { SummarySection },
  data(): any {
    return {};
  },
  computed: {
    ...mapGetters('interviewRequest', ['sitterFallback', 'basicDetails', 'interviewDetails']),
    startTime(): Date | null {
      return this.basicDetails.startTime ? parseISO(this.basicDetails.startTime) : null;
    },
    endTime(): Date | null {
      return this.basicDetails.endTime ? parseISO(this.basicDetails.endTime) : null;
    },
    jobTitle(): string {
      return `Job: ${this.interviewDetails.jobTitle}`;
    },
    isVirtual(): boolean {
      return this.basicDetails.virtual === true;
    },
    renderDateFormatted(): string {
      return this.startTime ? dateFormatted(this.startTime) : '';
    },
    renderTimeZone(): string {
      return this.startTime ? format(this.startTime, 'zzz') : '';
    },
    renderTimeFrame(): string | null {
      return this.startTime && this.endTime ? timeFrame(this.startTime, this.endTime) : null;
    },
    sections() {
      const sections = [
        {
          label: 'When',
          text: `${this.renderDateFormatted} ${this.renderTimeFrame} ${this.renderTimeZone}`.trim(),
        },
        {
          label: 'Where',
          text: this.isVirtual ? `Phone interview` : `In-person interview`,
          additionalText: this.isVirtual
            ? `We'll provide ${this.sitterFallback}'s phone number when the interview is confirmed.`
            : this.basicDetails.address,
        },
      ];

      // Add Details section if there are interview details
      if (this.interviewDetails.details && this.interviewDetails.details !== '') {
        const detailsText = this.jobTitle ? `${this.jobTitle}` : this.interviewDetails.details;
        const additionalDetailsText = this.jobTitle ? this.interviewDetails.details : '';
        sections.push({
          label: 'Details',
          text: detailsText,
          additionalText: additionalDetailsText,
        });
      }

      return sections;
    },
  },
};
</script>
